import { getFormattedDateString } from "@pulse/shared-components";

export const getFormattedDateAndTimeString = (date: Date): string => {
  const hours = date.getHours() % 12 || 12;
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const meridiem = date.getHours() >= 12 ? "PM" : "AM";

  return `${hours}:${minutes} ${meridiem} on ${getFormattedDateString(date)}`;
};
